import { userConstants } from "../constants/login.constants";

 function documentHistoryDocDetails(state = {}, action) {
    switch (action.type) {
        case userConstants.DOCUMENTHISTORYDOCREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.DOCUMENTHISTORYDOCREPORT_SUCCESS:
            return {
                items: action.documentHistoryDocDetails
            };
        case userConstants.DOCUMENTHISTORYDOCREPORT_FAILURE:
            return {
                error: action.errorDocumentHistory
                
            };
        default:
            return state
    }
}
export default documentHistoryDocDetails;